<template>
    <div ref="svgHolder">
        <svg ref="svg" version="1.0" xmlns="http://www.w3.org/2000/svg"
            :width="width * scale" :height="width * scale"
            :viewBox="`0 0 ${width * scale} ${width * scale}`"
            class="position-absolute" :style="{ left: left + 'px', }"
            preserveAspectRatio="xMidYMid meet">

            <g :transform="`translate(0, ${width * scale}) scale(${scale * defaultScale},-${scale * defaultScale})`"
            :fill="color" stroke="none">
            <path ref="path" d="M6996 11790 c-482 -55 -923 -218 -1325 -488 -171 -114 -201 -138
            -371 -288 -656 -579 -1124 -1475 -1274 -2444 -40 -257 -50 -404 -51 -730 0
            -318 5 -395 41 -665 92 -679 350 -1349 728 -1888 557 -795 1381 -1316 2213
            -1397 178 -17 163 -9 160 -85 -2 -60 -4 -65 -25 -65 -18 0 -28 -11 -47 -54
            -13 -30 -32 -85 -42 -121 -18 -69 -25 -78 -116 -148 -44 -33 -40 -47 19 -78
            l44 -24 0 -90 c1 -286 95 -530 329 -854 94 -130 115 -178 114 -270 -1 -141
            -49 -384 -114 -567 -17 -49 -60 -157 -94 -239 -69 -163 -89 -233 -80 -277 4
            -15 9 -28 11 -28 16 0 64 32 59 40 -10 16 21 110 95 284 109 259 161 449 190
            698 12 102 3 195 -25 249 -8 14 -66 104 -130 200 -199 297 -269 469 -282 700
            -8 138 -4 153 45 167 66 20 94 16 122 -18 27 -33 75 -49 146 -50 55 0 140 43
            148 75 4 16 14 25 25 25 40 0 144 -40 211 -80 58 -35 72 -40 89 -30 26 14 26
            18 -2 44 -18 17 -25 37 -30 87 -5 40 -18 87 -37 125 -26 53 -36 64 -73 79 -50
            20 -87 52 -87 76 0 9 -6 22 -13 28 -8 6 -14 35 -16 68 -1 32 -4 72 -7 90 -7
            35 -5 35 106 48 302 36 684 163 990 330 552 300 1052 812 1388 1421 264 479
            439 1023 512 1599 77 612 31 1257 -134 1850 -73 262 -179 541 -288 759 -94
            187 -145 276 -258 445 -86 131 -93 141 -197 271 -533 671 -1216 1084 -1993
            1205 -123 19 -552 29 -674 15z m-1290 -1223 c2 -1 -48 -105 -110 -230 -71
            -142 -121 -256 -134 -304 -42 -156 -70 -419 -80 -753 l-7 -205 -300 0 -300 0
            3 230 c2 127 10 273 17 327 26 179 84 381 195 678 82 219 100 258 119 264 17
            5 591 -1 597 -7z m841 0 c3 -4 -44 -104 -104 -225 -61 -120 -119 -250 -131
            -288 -48 -161 -73 -403 -95 -924 l-2 -55 -300 0 -300 0 3 90 c13 421 20 507
            57 649 64 251 227 708 268 749 19 19 29 20 309 15 159 -3 292 -8 295 -11z
            m-506 -1593 l134 -7 -12 -111 c-26 -247 -27 -315 -4 -403 11 -45 21 -88 21
            -96 0 -12 -28 -16 -147 -21 -82 -3 -198 -8 -259 -12 -111 -6 -111 -6 -118 17
            -25 88 -45 523 -27 589 4 14 18 30 31 37 28 14 171 17 381 7z m-698 -61 c2 -5
            -2 -55 -9 -113 -7 -58 -16 -154 -19 -215 -5 -95 -3 -122 18 -201 l23 -91 -110
            -7 c-61 -4 -177 -12 -259 -18 -81 -6 -150 -8 -153 -5 -22 22 -53 464 -39 572
            11 88 0 85 290 85 140 0 256 -3 258 -7z"/>


            <path class="d-none" ref="heart" d="M1976 5219 c-277 -40 -542 -201 -710 -429 -239 -324 -246 -763 -22
            -1296 154 -365 502 -849 960 -1334 231 -245 930 -938 985 -976 18 -13 28 -4
            586 545 474 467 686 702 951 1056 402 535 594 992 594 1415 0 129 -15 217 -54
            332 -88 257 -264 456 -512 579 -154 76 -273 107 -443 115 -463 24 -752 -148
            -1027 -609 -37 -61 -72 -118 -77 -125 -7 -9 -20 5 -50 55 -239 406 -388 546
            -674 636 -131 42 -359 58 -507 36z"/>
            </g>
        </svg>
    </div>
</template>

<script>
import KUTE from 'kute.js'
export default {
    props: {
        color:{
            default: '#f77676',
        },
        scale: {
            default: 1,
        },
        width: {
            default: 150,
        },
        delay: {
            default: 1000,
        },
        duration: {
            default: 10000,
        },
        left: {
            default: 0,
        },
        morph: {
            default: false,
        },
    },
    mounted() {
        let ceiling = 2000
        let duration = this.duration
        if(this.morph) {
            KUTE.to(this.$refs.path, { path: this.$refs.heart },
                { delay: 1000, duration: 10000, repeat: 0, yoyo: false, }
            ).start();
            ceiling = window.innerHeight * 2 / 3
            duration /= 5
        }

        let ocilate = KUTE.fromTo(this.$refs.svgHolder, {translateX: 0}, {translateX: 50}, { delay: this.delay, duration: 1000, repeat: 1000, yoyo:true, }).start()
        KUTE.to(this.$refs.svg, {translateY: -ceiling}, { delay: this.delay, duration, repeat: 0, yoyo:false, }).start()
        setTimeout(() => {
            ocilate.stop()
            this.$destroy()
        }, this.delay + this.duration)
    },
    destroyed(){
        
    },
    data() {
        return {
            defaultScale: 0.01,
        }
    },
}
</script>

<style scoped>
    .heart{
        transform: scale(10);
    }
</style>